export const theme = {
  breakpoints: {
    forTabletLandscapeUp: '900px',
  },
  colors: {
    background: '#100F2C',
    gray: '#E4E5E7',
    white: '#FAFAFA',
    primary: '#FACC15',
    primaryDark: '#A68A1E',
    secondary: '#36E99E',
  },
  font: {
    family: 'Roboto',
    weights: {
      regular: 400,
      medium: 500,
    },
  },
}
